import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import NewContractButton from './NewContractButton';

const EmptyState = () => {
  const [isHovered, setIsHovered] = useState(false);
  const userString = localStorage.getItem('user');
  const userObject = userString ? JSON.parse(userString) : null;
  const email = userObject?.email;

  const handleClick = () => {
        e.stopPropagation();
        // Record analytics event
        newrelic.recordCustomEvent('AnalyticEvent', { 
            element: 'NewContractButton', 
            action: 'click', 
            email 
          });
  };


  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 pb-20">
      <div className="relative">
        {/* Animated circles background */}
        <div className={`absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-500 
          ${isHovered ? 'scale-110 opacity-100' : 'scale-100 opacity-50'}`}>
          <div className="absolute -inset-16 rounded-full border-2 border-green-500/20 animate-[spin_8s_linear_infinite]" />
          <div className="absolute -inset-32 rounded-full border-2 border-green-500/10 animate-[spin_12s_linear_infinite]" />
          <div className="absolute -inset-48 rounded-full border-2 border-green-500/5 animate-[spin_16s_linear_infinite]" />
        </div>

        {/* Main content */}
        <div className="relative flex flex-col items-center space-y-8 z-10">
          {/* <div className={`transition-transform duration-500 ${isHovered ? 'scale-110' : 'scale-100'}`}>
            <div className="w-24 h-24 bg-green-500/10 rounded-full flex items-center justify-center">
              <svg viewBox="0 0 24 24" className="w-12 h-12 text-green-600">
                <path 
                  fill="currentColor" 
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" 
                />
              </svg>
            </div>
          </div> */}

          <div className={`text-center transition-all duration-500 ${isHovered ? 'transform -translate-y-2' : ''}`}>
            <h1 className="text-3xl font-inter mb-8">Welcome to Shishito</h1>
            <h2 className="text-slate-600 text-[15px] text-center font-[Inter] max-w-md mb-8">
              Get started by building your first offer to buy below
            </h2>
          </div>

          <div 
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="relative"
          >
            
            <Link to="/newcontractform" onClick={handleClick} className={`absolute inset-0 bg-green-500/20 rounded-lg blur-xl transition-all duration-500
              ${isHovered ? 'opacity-100 scale-125' : 'opacity-0 scale-100'}`} 
            />
            <NewContractButton email={email} onClick={handleClick}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;